import {
  loginRequest,
  loginSuccess,
  loginFailure,
  updateLangRequest,
  updateLangSuccess,
  updateLangFailure,
} from './actions';
import { requestAPI } from '../../../../utils/request';
import { fetchAreasIfNeeded } from '../../appData/areas/index';
import { fetchCarsIfNeeded } from '../cars/index';
import redirectToPath from '../../../../utils/redirectToPath';
import { fetchFleetsIfNeeded } from '../../appData/fleets/index';
import { fetchCategoriesIfNeeded } from '../categories/thunk';
import { fetchCircles } from '../circles';
import { fetchProfiles } from '../profiles';
import { fetchTextsIfNeeded } from '../../appData/texts/thunk';
import { fetchPricingsIfNeeded } from '../../appData/pricings/thunk';
import message from '../../../../utils/message';

export const login = (token: string) => (dispatch: any) => {
  dispatch(loginRequest());
  requestAPI(`/fleets/admin`)
    .then(async (data) => {
      dispatch(loginSuccess({ ...data, token: token }));
      if (data && data.id) {
        window.localStorage.setItem('userData', JSON.stringify(data));
      }
    })
    .catch((err) => {
      dispatch(loginFailure(err));
    });
};

export const loginByLocalStorage = () => (dispatch: any) => {
  const remember = window.localStorage.getItem('rememberUser');
  const token = window.localStorage.getItem('userToken');

  if (window?.localStorage?.getItem('userData') && token) {
    // @ts-ignore
    try {
      const data = JSON.parse(window.localStorage.getItem('userData'));
      dispatch(loginSuccess({ ...data, token: token }));
      if (remember) {
        // saveCookieToken({ ...data, token });
      }
      setTimeout(() => {
        dispatch(login(token));
        if (data?.permissions?.fleetManager) {
          dispatch(fetchCarsIfNeeded());
          dispatch(fetchAreasIfNeeded());
          dispatch(fetchProfiles());
          dispatch(fetchFleetsIfNeeded());
          dispatch(fetchCategoriesIfNeeded());
        }
        if (data?.permissions?.userGroupsManager) {
          dispatch(fetchCircles());
        }
        if (data?.permissions?.paymentManager) {
          dispatch(fetchPricingsIfNeeded());
        }
        dispatch(fetchTextsIfNeeded());
      }, 30);
    } catch (e) {
      dispatch(loginFailure(e));
    }
  } else {
    redirectToPath('/login.html');
  }
};

export const updateAdminLanguage =
  (admin: any, id) => (dispatch: any, getState: any) => {
    dispatch(updateLangRequest());
    return requestAPI(
      `/fleets/admins/${id}`,
      {},
      {
        method: 'PUT',
        body: JSON.stringify(admin),
      }
    )
      .then((user) => {
        dispatch(updateLangSuccess(user.locale));
        message.success('Admin updated');
      })
      .catch((err) => {
        dispatch(updateLangFailure(err));
        message.error(err.message);
      });
  };
